/* -------------------------------------------------------------------------
 * Sayuri signature · aurora  (Hokkaidō Hikari)
 * -------------------------------------------------------------------------
 * Port of `Aurora` in the design file (line ~1177). Four tall, blurred,
 * screen-blended color bands in the upper sky, alternating accent /
 * accent-soft, swaying horizontally on two phase-offset cycles.
 *
 * Scent character: "Snow over the lavender field, woodsmoke from a far
 * cabin." Cold + ethereal + distant.
 * ----------------------------------------------------------------------- */
(function () {
  'use strict';
  var SA = window.SayuriAnimations;
  if (!SA) { return; }

  SA.register('aurora', {
    mount: function (el, ctx) {
      // Aurora is a fixed 4-band composition, not intensity-scaled.
      var accent = ctx.accent;
      var accentSoft = ctx.accentSoft;

      var frag = document.createDocumentFragment();
      for (var i = 0; i < 4; i++) {
        var color = (i % 2) ? accent : accentSoft;
        var p = document.createElement('div');
        p.className = 'sayuri-aurora-band';
        p.style.position = 'absolute';
        p.style.left = (i * 25 - 10) + '%';
        p.style.top = '-10%';
        p.style.width = '50%';
        p.style.height = '60%';
        p.style.background =
          'linear-gradient(180deg, ' + color + '55 0%, transparent 70%)';
        p.style.filter = 'blur(60px)';
        // Slowed from (12 + i*3) → (28 + i*6) so the bands feel
        // ethereal-Hokkaido instead of city-fast. Spread: 28,34,40,46s.
        p.style.animation = 'aurora-' + (i % 2) + ' ' + (28 + i * 6) + 's ease-in-out infinite';
        p.style.mixBlendMode = 'screen';

        frag.appendChild(p);
      }
      el.appendChild(frag);
    },
    css: [
      '@keyframes aurora-0 { 0%,100%{transform:translateX(0) scaleY(1);} 50%{transform:translateX(40px) scaleY(1.2);} }',
      '@keyframes aurora-1 { 0%,100%{transform:translateX(0) scaleY(1.1);} 50%{transform:translateX(-50px) scaleY(0.9);} }'
    ].join('')
  });
})();
